import React from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import PropTypes from 'prop-types';
import produce from 'immer';
import DOMPurify from 'isomorphic-dompurify';
import Select from '@digital-hig/mui/dist/Select';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormControl from '@mui/material/FormControl';
// eslint-disable-next-line import/no-extraneous-dependencies
import InputLabel from '@mui/material/InputLabel';

const QuizTypeMatchingMobile = ({
  question, quizState, setQuizState, isEveryQuestionAnswered, answers, setAnswers, isSignedIn,
}) => {
  const isMatchingProblemAnswered = (updatedQuizState, questionId) => {
    let areAllTermsHasResponse;
    updatedQuizState.questions.forEach((q) => {
      if (q.id === questionId) {
        areAllTermsHasResponse = q.terms.filter((term) => term.response === undefined);
      }
    });
    return areAllTermsHasResponse.length === 0;
  };

  const handleMatchingMobileOnChange = (e, matchingQuestion, termId) => {
    let updatedAnswers;
    const answerId = e.target.value;
    const updatedQuizState = produce(quizState, (draftState) => {
      if (draftState.questions) {
        draftState.questions.forEach((quesn) => {
          const q = quesn;
          if (q.id === matchingQuestion.id) {
            const selectedAnswer = q.answers.find((ans) => ans.id === answerId);
            const selectedTerm = q.terms.find((term) => term.id === termId);
            if (selectedAnswer) {
              selectedTerm.response = {
                children: selectedAnswer.text,
                value: selectedAnswer.id,
              };
            }

            // checking the selected answer was already been selected for other premise
            const otherPremises = q.terms.filter((term) => term.id !== termId);
            const hasResponse = otherPremises.find((term) => term.response?.value === answerId);
            if (hasResponse) {
              delete hasResponse.response;
            }
          }
        });
      }
    });
    setQuizState(updatedQuizState);

    if (isMatchingProblemAnswered(updatedQuizState, matchingQuestion.id)) {
      let matchingAns = {};
      updatedQuizState.questions.forEach((q) => {
        if (q.id === matchingQuestion.id) {
          matchingAns = {};
          q.terms.forEach((term) => {
            if ('response' in term) {
              matchingAns[term.id] = term.response.value;
            }
          });
        }
      });

      updatedAnswers = produce(answers, (draftState) => {
        draftState[matchingQuestion.id] = [matchingAns];
      });
    } else {
      updatedAnswers = produce(answers, (draftState) => {
        if (matchingQuestion.id in draftState) {
          delete draftState[matchingQuestion.id];
        }
      });
    }
    setAnswers(updatedAnswers);

    isEveryQuestionAnswered(updatedAnswers, updatedQuizState);
  };
  return (
    <RootElement>
      <Grid className="mobile-premise-container">
        {question.terms.map((term) => (
          <Grid key={term.id} className="item-container">
            <FormControl
              disabled={quizState.showReset || !isSignedIn}
              fullWidth
              key={term.id}
              id={term.id}
              variant="outlined"
            >
              <InputLabel htmlFor={term.id}><Typography component="span" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(term.text) }} /></InputLabel>
              {term.response
                ? (
                  <Select
                    key={`matching-select-box-${term.id}`}
                    onChange={(e) => handleMatchingMobileOnChange(e, question, term.id)}
                    options={[...[{ children: 'Select...', value: 'Select' }], ...question.answers.map((ans) => ({ children: ans.text, value: ans.id }))]}
                    defaultValue={term.response.value}
                  />
                )
                : (
                  <Select
                    key={`matching-select-box-sel-${term.id}`}
                    onChange={(e) => handleMatchingMobileOnChange(e, question, term.id)}
                    options={[...[{ children: 'Select...', value: 'Select' }], ...question.answers.map((ans) => ({ children: ans.text, value: ans.id }))]}
                    defaultValue="Select"
                  />
                )}

            </FormControl>
          </Grid>
        ))}
      </Grid>
    </RootElement>
  );
};

const RootElement = styled.div`
  .item-container{
    margin-top: 18px;
  }
`;

QuizTypeMatchingMobile.propTypes = {
  question: PropTypes.arrayOf({}).isRequired,
  answers: PropTypes.shape({}).isRequired,
  isEveryQuestionAnswered: PropTypes.func.isRequired,
  setAnswers: PropTypes.func.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  quizState: PropTypes.shape({
    showReset: PropTypes.bool,
    unansweredQuestions: PropTypes.arrayOf(),
    showUnanswered: PropTypes.string,
  }).isRequired,
  setQuizState: PropTypes.func.isRequired,
};

export default React.memo(QuizTypeMatchingMobile);
